<style scoped>
.loader {
position: absolute;
top :0;
left: 0;
right: 0;
bottom: 0;
margin: auto;
}
</style>

<template lang="pug">
  .main-content-padded
    .row
      .col.s12.m12
        table.striped
          thead
            tr
              th.table-header.sortable
                | Email Template
              th.table-header.sortable
                | Last modification
          tbody
            //- tr
            tr(v-for='(temp, index) in templates.templates')
              td
                router-link(:to="`/Newsletter-view/${temp.id}`" ) {{temp.name}}
              td {{temp.modifiedAt | date}}
            div.preloader-wrapper.big.active.loader(v-if='!templates.templates')
              div.spinner-layer.spinner-green-only
                div.circle-clipper.left
                  div.circle
                div.gap-patch
                  div.circle
                div.circle-clipper.right
                  div.circle


            //- p.title.medium.grey-text.center-align Nothing to Show

</template>
<script>
import axios from 'axios'
import moment from 'moment'
export default {
  meta: {
    title: 'Newsletter Subscribers'
  },
  data () {
    return {
      templates: []
    }
  },
  mounted () {
    this.getTemplates()
  },
  filters: {
    date: function (val) {
      return moment(val).format('MMM DD, YYYY')
      // return moment(val).format('MMM DD, YYYY, h:mm:ss a')
    }
  },
  computed: {},
  methods: {
    getTemplates () {
      this.$store.dispatch('auth/getAccessToken').then(accessToken => {
        axios
          .get(`${this.$config.API_URL}/admin/sib-email-template-list`, {
            headers: {
              Authorization: `Bearer ${accessToken}`
            }
          })
          .then(result => {
            this.templates = result.data
          })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/page-newsletter-list.vue